import { useContext, useEffect, useState } from 'react';

import { FeatureFlagContext } from '../../../FeatureFlag/FeatureFlagProvider';
import * as _ from 'lodash';

const useFeature = (featureKey) => {
    const [feature, setFeature] = useState();
    const featureFlagContext = useContext(FeatureFlagContext);

    useEffect(() => {
        if (!_.isEmpty(featureFlagContext)) {
            setFeature(featureFlagContext[featureKey]);
        }
    }, [featureFlagContext, featureKey]);
    return feature;
};

export default useFeature;
